__webpack_require__.p = "https://PartnersWeb.shipbob.com/";